module.exports = __webpack_public_path__ + "static/media/cyber.4d5e9167.png";